import { Injectable } from '@angular/core';
import { Modal } from '../model/modal-print-pdf';
import { UtilitiesService } from './Utility/utilities.service';

@Injectable()
export class PdfService {

  constructor(private utilitiesService: UtilitiesService) { }

  printJS(paramsArgs) {
    const params = {
      printable: null,
      fallbackPrintable: null,
      type: 'pdf',
      header: null,
      headerStyle: 'font-weight: 300;',
      maxWidth: 800,
      font: 'TimesNewRoman',
      font_size: '12pt',
      honorMarginPadding: true,
      honorColor: false,
      properties: null,
      gridHeaderStyle: 'font-weight: bold; padding: 5px; border: 1px solid #dddddd;',
      gridStyle: 'border: 1px solid lightgray; margin-bottom: -1px;',
      showModal: false,
      onError: (error) => { throw new Error(error); },
      onLoadingStart: null,
      onLoadingEnd: null,
      onPrintDialogClose: null,
      onPdfOpen: null,
      modalMessage: 'Retrieving Document...',
      frameId: 'printJS',
      htmlData: '',
      documentTitle: 'Document',
      targetStyle: ['clear', 'display', 'width', 'min-width', 'height', 'min-height', 'max-height'],
      targetStyles: ['border', 'box', 'break', 'text-decoration'],
      ignoreElements: [],
      imageStyle: 'width:100%;',
      repeatTableHeader: true,
      css: null,
      style: null,
      scanStyles: true,
      arrayBuffer: null
    };

    // Check if a printable document or object was supplied
    const args = paramsArgs;
    if (args === undefined) {
      throw new Error('printJS expects at least 1 attribute.');
     }

    console.log('URLBLOB: ' + paramsArgs.printable);

    // Process parameters
    switch (typeof args) {
      case 'string':
        params.printable = encodeURI(args);
        params.fallbackPrintable = params.printable;
        params.type = arguments[1] || params.type;
        break;
      case 'object':
        params.printable = args.printable;
        params.fallbackPrintable = typeof args.fallbackPrintable !== 'undefined' ? args.fallbackPrintable : params.printable;
        params.type = typeof args.type !== 'undefined' ? args.type : params.type;
        params.frameId = typeof args.frameId !== 'undefined' ? args.frameId : params.frameId;
        params.header = typeof args.header !== 'undefined' ? args.header : params.header;
        params.headerStyle = typeof args.headerStyle !== 'undefined' ? args.headerStyle : params.headerStyle;
        params.maxWidth = typeof args.maxWidth !== 'undefined' ? args.maxWidth : params.maxWidth;
        params.font = typeof args.font !== 'undefined' ? args.font : params.font;
        params.font_size = typeof args.font_size !== 'undefined' ? args.font_size : params.font_size;
        params.honorMarginPadding = typeof args.honorMarginPadding !== 'undefined' ? args.honorMarginPadding : params.honorMarginPadding;
        params.properties = typeof args.properties !== 'undefined' ? args.properties : params.properties;
        params.gridHeaderStyle = typeof args.gridHeaderStyle !== 'undefined' ? args.gridHeaderStyle : params.gridHeaderStyle;
        params.gridStyle = typeof args.gridStyle !== 'undefined' ? args.gridStyle : params.gridStyle;
        params.showModal = typeof args.showModal !== 'undefined' ? args.showModal : params.showModal;
        params.onError = typeof args.onError !== 'undefined' ? args.onError : params.onError;
        params.onLoadingStart = typeof args.onLoadingStart !== 'undefined' ? args.onLoadingStart : params.onLoadingStart;
        params.onLoadingEnd = typeof args.onLoadingEnd !== 'undefined' ? args.onLoadingEnd : params.onLoadingEnd;
        params.onPrintDialogClose = typeof args.onPrintDialogClose !== 'undefined' ? args.onPrintDialogClose : params.onPrintDialogClose;
        params.onPdfOpen = typeof args.onPdfOpen !== 'undefined' ? args.onPdfOpen : params.onPdfOpen;
        params.modalMessage = typeof args.modalMessage !== 'undefined' ? args.modalMessage : params.modalMessage;
        params.documentTitle = typeof args.documentTitle !== 'undefined' ? args.documentTitle : params.documentTitle;
        params.targetStyle = typeof args.targetStyle !== 'undefined' ? args.targetStyle : params.targetStyle;
        params.targetStyles = typeof args.targetStyles !== 'undefined' ? args.targetStyles : params.targetStyles;
        params.ignoreElements = typeof args.ignoreElements !== 'undefined' ? args.ignoreElements : params.ignoreElements;
        params.imageStyle = typeof args.imageStyle !== 'undefined' ? args.imageStyle : params.imageStyle;
        params.repeatTableHeader = typeof args.repeatTableHeader !== 'undefined' ? args.repeatTableHeader : params.repeatTableHeader;
        params.css = typeof args.css !== 'undefined' ? args.css : params.css;
        params.style = typeof args.style !== 'undefined' ? args.style : params.style;
        params.scanStyles = typeof args.scanStyles !== 'undefined' ? args.scanStyles : params.scanStyles;
        params.arrayBuffer = typeof args.arrayBuffer !== 'undefined' ? args.arrayBuffer : params.arrayBuffer;
        break;
      default:
        throw new Error('Unexpected argument type! Expected "string" or "object", got ' + typeof args);
    }

    // Validate printable
    if (!params.printable) {
      throw new Error('Missing printable information.');
    }
    // Validate type
    if (!params.type || typeof params.type !== 'string' || ['pdf', 'html', 'image', 'json'].indexOf(params.type.toLowerCase()) === -1) {
      throw new Error('Invalid print type. Available types are: pdf, html, image and json.');
    }

    // Check if we are showing a feedback message to the user (useful for large files)
    if (params.showModal) {
      Modal.show(params);
    }

    // Check for a print start hook function
    if (params.onLoadingStart) { params.onLoadingStart(); }

    // To prevent duplication and issues, remove any used printFrame from the DOM
    const usedFrame = document.getElementById(params.frameId);

    if (usedFrame) { usedFrame.parentNode.removeChild(usedFrame); }

    // Create a new iframe or embed element (IE prints blank pdf's if we use iframe)
    const printFrame = document.createElement('iframe') as HTMLIFrameElement;

    // Hide iframe
    printFrame.setAttribute('style', 'visibility: hidden; height: 0; width: 0; position: absolute;');

    // Set iframe element id
    printFrame.setAttribute('id', params.frameId);

    // For non pdf printing, pass an html document string to srcdoc (force onload callback)
    if (params.type !== 'pdf') {
      (<any>printFrame).srcdoc = '<html><head><title>' + params.documentTitle + '</title>';

      // Attach css files
      if (params.css !== null) {
        // Add support for single file
        if (!Array.isArray(params.css)) { params.css = [params.css]; }

        // Create link tags for each css file
        params.css.forEach(file => {
          (<any>printFrame).srcdoc += '<link rel="stylesheet" href="' + file + '">';
        });
      }

      (<any>printFrame).srcdoc += '</head><body></body></html>';
    }

    // Check printable type
    switch (params.type) {
      case 'pdf':
        // Check browser support for pdf and if not supported we will just open the pdf file instead
        if (this.utilitiesService.isFirefox() || this.utilitiesService.isEdge() || this.utilitiesService.isIE()) {
          try {
            console.log('PrintJS currently doesn\'t support PDF printing in Firefox, Internet Explorer and Edge.');
            if (this.utilitiesService.isFirefox()) {
              const win = window.open(params.fallbackPrintable, '_blank');
              win.focus();
            } else {
              const blobObject = new Blob([params.arrayBuffer], { type: 'application/pdf' });
              window.navigator.msSaveOrOpenBlob(blobObject, 'expediente.pdf');
            }

            if (params.onPdfOpen) { params.onPdfOpen(); }
          } catch (e) {
            params.onError(e);
          } finally {
            // Make sure there is no loading modal opened
            if (params.showModal) { Modal.close(); }
            if (params.onLoadingEnd) { params.onLoadingEnd(); }
          }
        } else {
          this.print(params, printFrame);
        }
        break;
    }
  }

  private print(params, printFrame) {
    params.printable = /^(blob|http)/i.test(params.printable)
      ? params.printable
      : window.location.origin + (params.printable.charAt(0) !== '/' ? '/' + params.printable : params.printable);

    // If showing a loading modal or using a hook function, we will preload the pdf file
    if (params.showModal || params.onLoadingStart) {
      // Get the file through a http request
      const req = new (<any>window).XMLHttpRequest();
      req.responseType = 'arraybuffer';

      req.addEventListener('load', () => {
        // Pass response data to a blob and create a local object url
        const localPdfBlob = new window.Blob([req.response], { type: 'application/pdf' });
        const localPdf = window.URL.createObjectURL(localPdfBlob);

        // Pass the url to the printable parameter (replacing the original pdf file url)
        // This will prevent a second request to the file (server) once the iframe loads
        params.printable = localPdf;

        this.send(params, printFrame);
      });

      req.open('GET', params.printable, true);
      req.send();
    } else {
      this.send(params, printFrame);
    }
  }
  private send(params: any, printFrame: any): any {
    printFrame.setAttribute('src', params.printable);

    // Append iframe element to document body
    document.getElementsByTagName('body')[0].appendChild(printFrame);

    // Get iframe element
    const iframeElement = document.getElementById(params.frameId) as HTMLIFrameElement;

    // Wait for iframe to load all content
    if (params.type === 'pdf' && (this.utilitiesService.isIE() || this.utilitiesService.isEdge())) {
      iframeElement.addEventListener('onload', () => {
        try {
          this.performPrint(iframeElement, params);
        } catch (error) {
          params.onError(error);
        } finally {
          this.cleanUp(params);
        }
      });
    } else {
      printFrame.onload = () => {
        if (params.type === 'pdf') {
          this.finishPrint(iframeElement, params);
        } else {
          // Get iframe element document
          let printDocument = (iframeElement.contentWindow || iframeElement.contentDocument);
          if ((<any>printDocument).document) { printDocument = (<any>printDocument).document; }

          // Inject printable html into iframe body
          (<any>printDocument).body.innerHTML = params.htmlData;

          // Add custom style
          if (params.type !== 'pdf' && params.style !== null) {
            // Create style element
            const style = document.createElement('style');
            style.innerHTML = params.style;

            // Append style element to iframe's head
            (<any>printDocument).head.appendChild(style);
          }
          this.finishPrint(iframeElement, params);
        }
      };
    }
  }

  private performPrint(iframeElement, params) {
    iframeElement.focus();

  // If Edge or IE, try catch with execCommand
    if (this.utilitiesService.isEdge() || this.utilitiesService.isIE()) {
      try {
        iframeElement.contentWindow.document.execCommand('print', false, null);
      } catch (e) {
        iframeElement.contentWindow.print();
      }
    } else {
      // Other browsers
      iframeElement.contentWindow.print();
    }
  }

private cleanUp(params) {
    // If we are showing a feedback message to user, remove it
  if (params.showModal) { Modal.close(); }

    // Check for a finished loading hook function
  if (params.onLoadingEnd) { params.onLoadingEnd(); }

    // If preloading pdf files, clean blob url
  if (params.showModal || params.onLoadingStart) { window.URL.revokeObjectURL(params.printable); }

    // If a onPrintDialogClose callback is given, execute it
    if (params.onPrintDialogClose) {
      let event = 'mouseover';

      if (!this.utilitiesService.isIE() && !this.utilitiesService.isEdge()) {
        // Firefox will require an extra click in the document
        // to fire the focus event. Should we console.warn that?
        event = 'focus';
      }
      const handler = () => {
        // Make sure the event only happens once.
        window.removeEventListener(event, handler);

        params.onPrintDialogClose();
      };

      window.addEventListener(event, handler);
    }
  }

private finishPrint(iframeElement, params) {
  try {
    this.performPrint(iframeElement, params);
  } catch (error) {
    params.onError(error);
  } finally {
    this.cleanUp(params);
  }
}

}

